export { default } from "./CurricVisualiser";
